import { PropsWithChildren } from 'react';

export const ContentWrapper = ({ children }: PropsWithChildren) => {
  return (
    <span className="flex flex-col items-end xl-msq:items-start self-start xl-msq:py-1.5">
      {children}
    </span>
  );
};
